import React from "react"

export default class Redirect extends React.Component  {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      url: null
    };
  }

  componentDidMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    this.updateDimensions();
  }

  updateDimensions = () => {
    this.setState({
      width: window.innerWidth
    }, () => {
      this.setURL();
    });
  };

  setURL = () => {
    if (this.state.width < 750) {
      this.setState({ url: '0; url=http://news.fullerton.edu/feature/temperature-rising/#chapter3' });
    } else if (this.state.width > 750) {
      this.setState({ url: '0; url=http://news.fullerton.edu/feature/temperature-rising/#view/3' });
    }
  };

  render() {
    // console.log(this.state.width);
    return (
      <React.Fragment>
        <meta http-equiv="refresh" content={this.state.url} />
        <p>If you are not automaticlly redirected, click this link: <a href="http://news.fullerton.edu/feature/temperature-rising/#view/3">http://news.fullerton.edu/feature/temperature-rising/#view/3</a></p>
      </React.Fragment>
    )
  }
}